import React from "react"
import { Blockquote } from "@wfp/ui"
import { RootState } from "store/store"
import { useAppSelector } from "hooks/hooksStore"

function AlertComponent() {
  const { alertMessage, alertType } = useAppSelector((state: RootState) => state.common)

  return alertMessage ? (
    <Blockquote kind={(alertType as any) || "success"} withIcon style={{ padding: "2rem" }}>
      {alertMessage}
    </Blockquote>
  ) : null
}

export default AlertComponent
